import React, { useContext, useEffect } from "react";
import { ContentProps } from "./types";
import { LabelModule } from "../Modules/LabelModule.tsx";
import { TextInputModule } from "../Modules/TextInputModule.tsx";
import { EmailInputModule } from "../Modules/EmailInputModule.tsx";
import { NumberInputModule } from "../Modules/NumberInputModule.tsx";
import { TextAreaModule } from "../Modules/TextAreaModule.tsx";
import { DateInputModule } from "../Modules/DateInputModule.tsx";
import { SingleChoiceModal1 } from "../Modules/SingleChoiceModal1.tsx";
import { SingleChoiceModal3 } from "../Modules/SingleChoiceModal3.tsx";
import { MultiChoiceModal1 } from "../Modules/MultiChoiceModal1.tsx";
import { MultiChoiceModal2 } from "../Modules/MultiChoiceModal2.tsx";
import { PrimaryButton } from "../../../../components/Modules/PrimaryButton.tsx";
import { SecondaryButton } from "../../../../components/Modules/SecondaryButton.tsx";
import { useOnboarding } from "./OnboardingContext";
import General from "../../../../general.ts";
import { leftArrow, rightArrow } from "../../../../assets/assetsSVG.tsx";
import QuestContext from "../../../../components/QuestWrapper.tsx";

const Content: React.FC<ContentProps> = () => {
  const {
    design,
    formdata,
    progress,
    progressBarMultiLine,
    template,
    controlBtnType,
    uiProps,
    nextBtnText,
    returnAnswers,
    answer,
    checkValidationValues,
    validateInputRegex,
    themeManager,
    currentPage = 0,
    setCurrentPage,
    handleUpdate,
    ProgressBar,
    questionTemplate,
    btnFlag,
    designState,
    onboardingGetPropsFunctions,
  } = useOnboarding();

  const { apiType } = useContext(QuestContext.Context);
  let GeneralFunctions = new General("mixpanel", apiType);

  useEffect(() => {
    if (
      designState &&
      currentPage >= designState.length &&
      designState.length > 0
    ) {
      setCurrentPage && setCurrentPage(designState.length - 1);
    }
  }, [designState, currentPage, setCurrentPage]);

  const getCurrentPageItems = () => {
    if (
      !designState ||
      !Array.isArray(designState) ||
      designState.length === 0
    ) {
      return [];
    }
    const safePage = Math.min(currentPage, designState.length - 1);
    return designState[safePage] || [];
  };
  return (
    <>
      <div className="q-onb-main-first">
        {questionTemplate === "multi-question" &&
          formdata.length > 0 &&
          designState.length > 1 &&
          !!progress?.length && <ProgressBar />}

        {!!designState && designState.length > 0
          ? designState[currentPage].map((num: number, index: number) => {
              const currentFormData = formdata[num - 1];
              if (!currentFormData) return null;

              switch (currentFormData.type) {
                case "USER_INPUT_TEXT":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${currentFormData?.question || ""} ${
                          !!currentFormData?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <TextInputModule
                        placeholder={
                          currentFormData?.placeholder ||
                          currentFormData?.question ||
                          ""
                        }
                        value={answer[currentFormData.actionId || ""]}
                        validateInputRegex={(validation) =>
                          validateInputRegex(
                            validation,
                            currentFormData.actionId
                          )
                        }
                        errorText={themeManager.getTextInputErrorText()}
                        textErrorStyle={themeManager.getTextInputErrorStyles()}
                        regexKey={currentFormData?.regexKey}
                        regexMessage={currentFormData?.regexMessage}
                        onChange={(e) =>
                          handleUpdate(e, currentFormData.actionId || "", "")
                        }
                        style={themeManager.getTextInputStyles()}
                        name={`input-${designState?.[currentPage]?.[index]}`}
                        key={currentFormData.actionId}
                      />
                    </div>
                  );

                case "USER_INPUT_EMAIL":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${currentFormData?.question || ""} ${
                          !!currentFormData?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <EmailInputModule
                        placeholder={
                          currentFormData?.placeholder ||
                          currentFormData?.question ||
                          ""
                        }
                        value={answer[currentFormData.actionId || ""]}
                        iconColor={themeManager.getEmailIconColor()}
                        validateInputRegex={(validation) =>
                          validateInputRegex(
                            validation,
                            currentFormData.actionId
                          )
                        }
                        regexKey={currentFormData?.regexKey}
                        regexMessage={currentFormData?.regexMessage}
                        onChange={(e) =>
                          handleUpdate(e, currentFormData.actionId || "", "")
                        }
                        style={themeManager.getTextInputStyles()}
                        emailtext={themeManager.getEmailInputErrorText()}
                        emailErrorStyle={themeManager.getEMailInputErrorStyles()}
                        name={`input-${designState?.[currentPage]?.[index]}`}
                        key={currentFormData.actionId}
                      />
                    </div>
                  );

                case "USER_INPUT_PHONE":
                case "USER_INPUT_NUMBER":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${currentFormData?.question || ""} ${
                          !!currentFormData?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <NumberInputModule
                        placeholder={
                          currentFormData?.placeholder ||
                          currentFormData?.question ||
                          ""
                        }
                        value={answer[currentFormData.actionId || ""]}
                        iconColor={themeManager.getEmailIconColor()}
                        validateInputRegex={(validation) =>
                          validateInputRegex(
                            validation,
                            currentFormData.actionId
                          )
                        }
                        numbertext={themeManager.getNumberInputErrorText()}
                        numberErrorStyle={themeManager.getNumberInputErrorStyles()}
                        regexKey={currentFormData?.regexKey}
                        regexMessage={currentFormData?.regexMessage}
                        onChange={(e) =>
                          handleUpdate(e, currentFormData.actionId || "", "")
                        }
                        style={themeManager.getTextInputStyles()}
                        name={`input-${designState?.[currentPage]?.[index]}`}
                        key={currentFormData?.actionId}
                      />
                    </div>
                  );
                case "USER_INPUT_TEXTAREA":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${currentFormData?.question || ""} ${
                          currentFormData?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <TextAreaModule
                        value={answer[currentFormData.actionId || ""]}
                        onChange={(e) =>
                          handleUpdate(e, currentFormData.actionId || "", "")
                        }
                        style={themeManager.getTextAreaInputStyles()}
                        validateInputRegex={(validation) =>
                          validateInputRegex(
                            validation,
                            currentFormData.actionId
                          )
                        }
                        textareatext={themeManager.getTextAreaInputErrorText()}
                        textareaErrorStyle={themeManager.getTextAreaInputErrorStyles()}
                        placeholder={
                          currentFormData?.placeholder ||
                          currentFormData?.question ||
                          ""
                        }
                        key={currentFormData?.actionId}
                      />
                    </div>
                  );

                case "USER_INPUT_DATE":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${currentFormData?.question || ""} ${
                          !!currentFormData?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <DateInputModule
                        placeholder={
                          currentFormData?.placeholder ||
                          currentFormData?.question ||
                          ""
                        }
                        value={answer[currentFormData.actionId || ""]}
                        onChange={(e) =>
                          handleUpdate(e, currentFormData.actionId || "", "")
                        }
                        iconColor={themeManager.getEmailIconColor()}
                        style={themeManager.getTextInputStyles()}
                        key={currentFormData?.actionId}
                        preventFutureSelection={false}
                        preventPastSelection={false}
                        minDate=""
                        maxDate=""
                      />
                    </div>
                  );

                case "USER_INPUT_SINGLE_CHOICE":
                  if (
                    !!onboardingGetPropsFunctions.getSingleChoose() &&
                    (onboardingGetPropsFunctions.getSingleChoose() ===
                      "modal1" ||
                      onboardingGetPropsFunctions.getSingleChoose() ===
                        "modal2")
                  ) {
                    return (
                      <div className="label-input-cont" key={index}>
                        <LabelModule
                          htmlFor=""
                          style={themeManager.getLabelStyles()}
                        >
                          {`${currentFormData?.question || ""} ${
                            !!currentFormData?.required ? "*" : ""
                          }`}
                        </LabelModule>
                        <SingleChoiceModal1
                          options={currentFormData.options || []}
                          type={onboardingGetPropsFunctions.getSingleChoose()}
                          onChange={(e) =>
                            handleUpdate(
                              e,
                              currentFormData.actionId || "",
                              "radio"
                            )
                          }
                          checked={answer[currentFormData.actionId || ""]}
                          style={themeManager.getSingleChoiceStyles()}
                          hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                          selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                          key={currentFormData?.actionId}
                        />
                        {currentFormData?.manualInput !== false &&
                          answer[currentFormData.actionId || ""] ===
                            currentFormData?.manualInput && (
                            <TextInputModule
                              type="text"
                              onChange={(e) =>
                                handleUpdate(
                                  e,
                                  currentFormData.actionId + "/manual",
                                  ""
                                )
                              }
                              value={
                                answer[currentFormData.actionId + "/manual"]
                              }
                              placeholder="Please fill manually"
                              style={themeManager.getTextInputStyles()}
                              key={currentFormData?.actionId}
                            />
                          )}
                      </div>
                    );
                  } else {
                    return (
                      <div className="label-input-cont" key={index}>
                        <LabelModule
                          htmlFor=""
                          style={themeManager.getLabelStyles()}
                        >
                          {`${currentFormData?.question || ""} ${
                            !!currentFormData?.required ? "*" : ""
                          }`}
                        </LabelModule>
                        <SingleChoiceModal3
                          options={currentFormData.options || []}
                          type={onboardingGetPropsFunctions.getSingleChoose()}
                          onChange={(e) =>
                            handleUpdate(
                              { target: e },
                              currentFormData.actionId || "",
                              ""
                            )
                          }
                          checked={answer[currentFormData.actionId || ""]}
                          style={themeManager.getSingleChoiceStyles()}
                          hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                          selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                          key={currentFormData?.actionId}
                        />
                      </div>
                    );
                  }

                case "USER_INPUT_MULTI_CHOICE":
                  if (
                    !!onboardingGetPropsFunctions.getMultiChoice() &&
                    onboardingGetPropsFunctions.getMultiChoice() === "modal2"
                  ) {
                    return (
                      <div className="label-input-cont" key={index}>
                        <LabelModule
                          htmlFor=""
                          style={themeManager.getLabelStyles()}
                        >
                          {`${currentFormData?.question || ""} ${
                            !!currentFormData?.required ? "*" : ""
                          }`}
                        </LabelModule>
                        <MultiChoiceModal2
                          options={currentFormData.options || []}
                          checked={
                            !!answer[currentFormData.actionId] &&
                            answer[currentFormData.actionId]
                          }
                          onChange={(e) =>
                            handleUpdate(
                              e,
                              currentFormData.actionId || "",
                              "check"
                            )
                          }
                          modalType={onboardingGetPropsFunctions.getMultiChoice()}
                          style={themeManager.getMultiChoiceStyles()}
                          selectedStyle={themeManager.getMultiChoiceSelectedStyles('modal2')}
                          key={currentFormData?.actionId}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <div className="label-input-cont" key={index}>
                        <LabelModule
                          htmlFor=""
                          style={themeManager.getLabelStyles()}
                        >
                          {`${currentFormData?.question || ""} ${
                            !!currentFormData?.required ? "*" : ""
                          }`}
                        </LabelModule>
                        <MultiChoiceModal1
                          options={currentFormData.options || []}
                          checked={
                            !!answer[currentFormData.actionId] &&
                            answer[currentFormData.actionId]
                          }
                          onChange={(e) =>
                            handleUpdate(
                              e,
                              currentFormData.actionId || "",
                              "check"
                            )
                          }
                          modalType={onboardingGetPropsFunctions.getMultiChoice()}
                          style={themeManager.getMultiChoiceStyles()}
                          selectedStyle={themeManager.getMultiChoiceSelectedStyles('modal1')}
                          key={currentFormData?.actionId}
                        />
                      </div>
                    );
                  }
                default:
                  return null;
              }
            })
          : formdata?.map((data, index) => {
              switch (data.type) {
                case "USER_INPUT_TEXT":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${data?.question || ""} ${
                          !!data?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <TextInputModule
                        placeholder={data?.placeholder || data?.question || ""}
                        value={answer[data?.actionId || ""]}
                        regexKey={data?.regexKey}
                        regexMessage={data?.regexMessage}
                        validateInputRegex={(validation) =>
                          validateInputRegex(validation, data.actionId)
                        }
                        errorText={themeManager.getTextInputErrorText()}
                        textErrorStyle={themeManager.getTextInputErrorStyles()}
                        onChange={(e) =>
                          handleUpdate(e, data.actionId || "", "")
                        }
                        style={themeManager.getTextInputStyles()}
                        name={`input-${designState?.[currentPage]?.[index]}`}
                        key={data?.actionId}
                      />
                    </div>
                  );

                case "USER_INPUT_EMAIL":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${data?.question || ""} ${
                          !!data?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <EmailInputModule
                        placeholder={data?.placeholder || data?.question || ""}
                        value={answer[data?.actionId || ""]}
                        iconColor={themeManager.getEmailIconColor()}
                        validateInputRegex={(validation) =>
                          validateInputRegex(validation, data.actionId)
                        }
                        regexKey={data?.regexKey}
                        regexMessage={data?.regexMessage}
                        onChange={(e) =>
                          handleUpdate(e, data.actionId || "", "")
                        }
                        style={themeManager.getTextInputStyles()}
                        emailtext={themeManager.getEmailInputErrorText()}
                        emailErrorStyle={themeManager.getEMailInputErrorStyles()}
                        name={`input-${designState?.[currentPage]?.[index]}`}
                        key={data?.actionId}
                      />
                    </div>
                  );

                case "USER_INPUT_PHONE":
                case "USER_INPUT_NUMBER":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${data?.question || ""} ${
                          !!data?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <NumberInputModule
                        placeholder={data?.placeholder || data?.question || ""}
                        value={answer[data.actionId || ""]}
                        iconColor={themeManager.getEmailIconColor()}
                        validateInputRegex={(validation) =>
                          validateInputRegex(validation, data.actionId)
                        }
                        numbertext={themeManager.getNumberInputErrorText()}
                        numberErrorStyle={themeManager.getNumberInputErrorStyles()}
                        regexKey={data?.regexKey}
                        regexMessage={data?.regexMessage}
                        onChange={(e) =>
                          handleUpdate(e, data.actionId || "", "")
                        }
                        style={themeManager.getTextInputStyles()}
                        name={`input-${designState?.[currentPage]?.[index]}`}
                        key={data?.actionId}
                      />
                    </div>
                  );

                case "USER_INPUT_TEXTAREA":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${data?.question || ""} ${
                          !!data?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <TextAreaModule
                        value={answer[data.actionId || ""]}
                        onChange={(e) =>
                          handleUpdate(e, data.actionId || "", "")
                        }
                        style={themeManager.getTextAreaInputStyles()}
                        validateInputRegex={(validation) =>
                          validateInputRegex(validation, data.actionId)
                        }
                        textareatext={themeManager.getTextAreaInputErrorText()}
                        textareaErrorStyle={themeManager.getTextAreaInputErrorStyles()}
                        placeholder={data?.placeholder || data?.question || ""}
                        key={data?.actionId}
                      />
                    </div>
                  );

                case "USER_INPUT_DATE":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${data?.question || ""} ${
                          !!data?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      <DateInputModule
                        type="date"
                        placeholder={data?.placeholder || data?.question || ""}
                        value={answer[data.actionId || ""]}
                        onChange={(e) =>
                          handleUpdate(e, data.actionId || "", "")
                        }
                        iconColor={themeManager.getEmailIconColor()}
                        style={themeManager.getTextInputStyles()}
                        key={data?.actionId}
                        preventFutureSelection={true}
                        preventPastSelection={true}
                        minDate=""
                        maxDate=""
                      />
                    </div>
                  );

                case "USER_INPUT_SINGLE_CHOICE":
                  if (
                    onboardingGetPropsFunctions.getSingleChoose() ===
                      "modal1" ||
                    onboardingGetPropsFunctions.getSingleChoose() === "modal2"
                  ) {
                    return (
                      <div className="label-input-cont" key={index}>
                        <LabelModule
                          htmlFor=""
                          style={themeManager.getLabelStyles()}
                        >
                          {`${data?.question || ""} ${
                            !!data?.required ? "*" : ""
                          }`}
                        </LabelModule>
                        <SingleChoiceModal1
                          options={data.options || []}
                          type={onboardingGetPropsFunctions.getSingleChoose()}
                          onChange={(e) =>
                            handleUpdate(e, data.actionId || "", "radio")
                          }
                          checked={answer[data.actionId || ""]}
                          style={themeManager.getSingleChoiceStyles()}
                          hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                          selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                          key={data?.actionId}
                        />
                        {data?.manualInput != false &&
                          answer[data.actionId || ""] == data?.manualInput && (
                            <TextInputModule
                              type="text"
                              onChange={(e) =>
                                handleUpdate(e, data.actionId + "/manual", "")
                              }
                              value={answer[data.actionId + "/manual"]}
                              placeholder="Please fill manually"
                              style={themeManager.getTextInputStyles()}
                              key={data?.actionId}
                            />
                          )}
                      </div>
                    );
                  } else {
                    return (
                      <div className="label-input-cont" key={index}>
                        <LabelModule
                          htmlFor=""
                          style={themeManager.getLabelStyles()}
                        >
                          {`${data?.question || ""} ${
                            !!data?.required ? "*" : ""
                          }`}
                        </LabelModule>
                        <SingleChoiceModal3
                          options={data.options || []}
                          type={onboardingGetPropsFunctions.getSingleChoose()}
                          onChange={(e) =>
                            handleUpdate({ target: e }, data.actionId || "", "")
                          }
                          checked={answer[data.actionId || ""]}
                          style={themeManager.getSingleChoiceStyles()}
                          hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                          selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                          key={data?.actionId}
                        />
                      </div>
                    );
                  }

                case "USER_INPUT_MULTI_CHOICE":
                  return (
                    <div className="label-input-cont" key={index}>
                      <LabelModule
                        htmlFor=""
                        style={themeManager.getLabelStyles()}
                      >
                        {`${data?.question || ""} ${
                          !!data?.required ? "*" : ""
                        }`}
                      </LabelModule>
                      {onboardingGetPropsFunctions.getMultiChoice() ===
                      "modal2" ? (
                        <MultiChoiceModal2
                          options={data.options || []}
                          checked={
                            !!answer[data.actionId] && answer[data.actionId]
                          }
                          onChange={(e) =>
                            handleUpdate(e, data.actionId || "", "check")
                          }
                          modalType={onboardingGetPropsFunctions.getMultiChoice()}
                          style={themeManager.getMultiChoiceStyles()}
                          selectedStyle={themeManager.getMultiChoiceSelectedStyles('modal2')}
                          key={data?.actionId}
                        />
                      ) : (
                        <MultiChoiceModal1
                          options={data.options || []}
                          checked={
                            !!answer[data.actionId] && answer[data.actionId]
                          }
                          onChange={(e) =>
                            handleUpdate(e, data.actionId || "", "check")
                          }
                          modalType={onboardingGetPropsFunctions.getMultiChoice()}
                          style={themeManager.getMultiChoiceStyles()}
                          selectedStyle={themeManager.getMultiChoiceSelectedStyles('modal1')}
                          key={data?.actionId}
                        />
                      )}
                    </div>
                  );

                default:
                  return null;
              }
            })}

        {formdata &&
          formdata.length > 0 &&
          (!!designState && designState.length > 1 ? (
            controlBtnType === "Buttons" ||
            uiProps?.controlBtnType === "Buttons" ? (
              <div className="q-onb-main-criteria">
                {currentPage > 0 && (
                  <SecondaryButton
                    style={{
                      opacity: currentPage === 0 ? "0" : "1",
                      cursor: currentPage === 0 ? "context-menu" : "pointer",
                      borderColor:
                        themeManager.getSecondaryButtonStyles().borderColor,
                      background:
                        themeManager.getSecondaryButtonStyles().background,
                      color: themeManager.getSecondaryButtonStyles().color,
                      ...themeManager.getSecondaryButtonStyles(),
                    }}
                    className="q-onb-main-btn"
                    onClick={() => {
                      GeneralFunctions.fireTrackingEvent(
                        "quest_onboarding_secondary_btn_clicked",
                        "onboarding"
                      );
                      currentPage > 0 &&
                        setCurrentPage &&
                        setCurrentPage(currentPage - 1);
                    }}
                  >
                    Previous
                  </SecondaryButton>
                )}
                <PrimaryButton
                  onClick={() => {
                    GeneralFunctions.fireTrackingEvent(
                      "quest_onboarding_primary_btn_clicked",
                      "onboarding"
                    );
                    if (checkValidationValues && checkValidationValues()) {
                      GeneralFunctions.fireTrackingEvent(
                        "quest_onboarding_primary_btn_clicked",
                        "onboarding"
                      );
                      currentPage !== designState.length - 1
                        ? setCurrentPage && setCurrentPage(currentPage + 1)
                        : returnAnswers && returnAnswers();
                    }
                  }}
                  type="submit"
                  disabled={
                    !btnFlag ||
                    !(checkValidationValues && checkValidationValues())
                  }
                  className="q-onb-main-btn2"
                  style={{
                    background:
                      themeManager.getPrimaryButtonStyles().background,
                    ...themeManager.getPrimaryButtonStyles(),
                  }}
                >
                  {currentPage == designState.length - 1
                    ? nextBtnText
                      ? nextBtnText
                      : "Submit"
                    : "Continue"}
                </PrimaryButton>
              </div>
            ) : (
              <div className="q-onb-main-arrow-div">
                <SecondaryButton
                  className="q-onb-main-arrow"
                  onClick={() => {
                    GeneralFunctions.fireTrackingEvent(
                      "quest_onboarding_secondary_btn_clicked",
                      "onboarding"
                    );
                    currentPage > 0 &&
                      setCurrentPage &&
                      setCurrentPage(currentPage - 1);
                  }}
                  style={{
                    opacity: currentPage == 0 ? "0" : "1",
                    cursor: currentPage == 0 ? "context-menu" : "pointer",
                    height: themeManager.getSecondaryButtonAeroStyles().height,
                    width: themeManager.getSecondaryButtonAeroStyles().width,
                    borderRadius:
                      themeManager.getSecondaryButtonAeroStyles().borderRadius,
                    padding:
                      themeManager.getSecondaryButtonAeroStyles().padding,
                    border:
                      themeManager.getSecondaryButtonAeroStyles().border ||
                      "1.5px solid #afafaf",
                    borderColor:
                      themeManager.getSecondaryButtonAeroStyles().borderColor,
                    backgroundColor:
                      themeManager.getSecondaryButtonAeroStyles()
                        .backgroundColor,
                    color: themeManager.getSecondaryButtonAeroStyles().color,
                    ...themeManager.getSecondaryButtonAeroStyles(),
                  }}
                >
                  {leftArrow()}
                </SecondaryButton>
                <PrimaryButton
                  className="q-onb-main-arrow2"
                  onClick={() => {
                    GeneralFunctions.fireTrackingEvent(
                      "quest_onboarding_primary_btn_clicked",
                      "onboarding"
                    );
                    if (checkValidationValues && checkValidationValues()) {
                      GeneralFunctions.fireTrackingEvent(
                        "quest_onboarding_primary_btn_clicked",
                        "onboarding"
                      );
                      currentPage !== designState.length - 1
                        ? setCurrentPage && setCurrentPage(currentPage + 1)
                        : returnAnswers && returnAnswers();
                    }
                  }}
                  type="submit"
                  disabled={
                    !btnFlag ||
                    !(checkValidationValues && checkValidationValues())
                  }
                  style={{
                    height: themeManager.getPrimaryButtonAeroStyles().height,
                    width: themeManager.getPrimaryButtonAeroStyles().width,
                    borderRadius:
                      themeManager.getPrimaryButtonAeroStyles().borderRadius,
                    padding: themeManager.getPrimaryButtonAeroStyles().padding,
                    border:
                      themeManager.getPrimaryButtonAeroStyles().border ||
                      "1.5px solid #D1ACFF",
                    borderColor:
                      themeManager.getSecondaryButtonAeroStyles().borderColor,
                    background:
                      themeManager.getPrimaryButtonAeroStyles().background,
                    ...themeManager.getPrimaryButtonAeroStyles(),
                  }}
                >
                  {rightArrow()}
                </PrimaryButton>
              </div>
            )
          ) : (
            <div>
              <PrimaryButton
                className="q-onb-main-btn3"
                onClick={() => {
                  GeneralFunctions.fireTrackingEvent(
                    "quest_onboarding_single_page_submit_button_clicked",
                    "onboarding"
                  );
                  if (checkValidationValues && checkValidationValues()) {
                    GeneralFunctions.fireTrackingEvent(
                      "quest_onboarding_primary_btn_clicked",
                      "onboarding"
                    );
                    currentPage !== designState.length - 1
                      ? setCurrentPage && setCurrentPage(currentPage + 1)
                      : returnAnswers && returnAnswers();
                  }
                }}
                type="submit"
                disabled={
                  !btnFlag ||
                  !(checkValidationValues && checkValidationValues())
                }
                style={{
                  border: themeManager.getNormalButtonStyles().border,
                  background: themeManager.getNormalButtonStyles().background,
                  ...themeManager.getNormalButtonStyles(),
                }}
              >
                {nextBtnText ? nextBtnText : "Continue"}
              </PrimaryButton>
            </div>
          ))}
      </div>
    </>
  );
};

export default Content;
